import { render, staticRenderFns } from "./AllCategoriesComponent.vue?vue&type=template&id=335030ba&scoped=true"
import script from "./AllCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./AllCategoriesComponent.vue?vue&type=script&lang=js"
import style0 from "./AllCategoriesComponent.vue?vue&type=style&index=0&id=335030ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335030ba",
  null
  
)

export default component.exports